import React from "react";
import LegalShell from "../components/LegalShell";

export default function Privacy() {
  return (
    <LegalShell title="Privacy Policy" kicker="Privacy" testid="page-privacy">
      <p>Your privacy matters. This policy explains what we collect, why, and your rights.</p>
      <h3 className="text-cream font-black text-lg mt-6">Data we collect</h3>
      <ul className="list-disc list-inside space-y-1">
        <li>Account: email, username, display name, password (hashed with bcrypt).</li>
        <li>Profile: avatar, bio, country, island (optional).</li>
        <li>Content: posts, comments, messages, gifts sent/received.</li>
        <li>Payment: PayPal order IDs and amounts. We never see your card details.</li>
        <li>Diagnostics: anonymous error logs (Sentry, if configured).</li>
      </ul>
      <h3 className="text-cream font-black text-lg mt-6">Why we collect it</h3>
      <p>To run the service, prevent abuse, process payments and payouts, and improve the product. We do not sell your personal data.</p>
      <h3 className="text-cream font-black text-lg mt-6">Storage & security</h3>
      <p>Data is stored on managed cloud infrastructure (MongoDB Atlas, Emergent object storage). Passwords are salted and hashed.</p>
      <h3 className="text-cream font-black text-lg mt-6">Your rights</h3>
      <ul className="list-disc list-inside space-y-1">
        <li>Access — request a copy of your data.</li>
        <li>Correct — edit your profile at any time.</li>
        <li>Delete — request full account deletion via support@giffwurldaunce.com (processed within 30 days).</li>
        <li>Withdraw consent — log out and stop using the service.</li>
      </ul>
      <h3 className="text-cream font-black text-lg mt-6">Children</h3>
      <p>Giffwurldaunce is not directed at children under 13. We do not knowingly collect their data.</p>
      <h3 className="text-cream font-black text-lg mt-6">Contact</h3>
      <p>privacy@giffwurldaunce.com</p>
    </LegalShell>
  );
}
